// extracted by mini-css-extract-plugin
export default {"mainContainer":"styles_mainContainer__RHVrT","homePMainList":"styles_homePMainList__au-Jx","iconGrid":"styles_iconGrid__XTB4M"};